import * as React from 'react'
export function Ok({ title = 'Ok', className, variation, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      data-variation={variation}
      {...props}
    >
      <title>{title}</title>
      <path
        d="M5 12L10 17L19 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Ok
